export enum ZoneTypeName {
    zone = 'Zone',
    topCategory = 'L2',
    category = 'L3',
    productType = 'L4',
}

/** API-level typeName as returned by the backend */
export type CategoryTypeName = 'zone' | 'topCategory' | 'category' | 'productType';

/** Maps CategoryTypeName to display label */
export const TYPE_LABEL: Record<CategoryTypeName, string> = {
    zone: 'Zone',
    topCategory: 'L2',
    category: 'L3',
    productType: 'L4',
};

/** Checkboxes are only available at L4 (productType) level */
export const TYPE_HAS_CHECKBOX: Record<CategoryTypeName, boolean> = {
    zone: false,
    topCategory: false,
    category: false,
    productType: true,
};

/** Maps zone typeName labels to ZoneCategoryId query param values */
export const ZoneCategoryIdByTypeName: Record<ZoneTypeName, number> = {
    [ZoneTypeName.zone]: 1,
    [ZoneTypeName.topCategory]: 2,
    [ZoneTypeName.category]: 3,
    [ZoneTypeName.productType]: 4,
};

export interface Country {
    countryId: number;
    countryCode: string;
    translatedCountryName: string;
    [key: string]: any;
}

export interface CategoryNode {
    categoryId: number;
    ownId: number;
    epimOwnId: number;
    description: string;
    typeName: CategoryTypeName;
    epimParentId: number | null;
    uniqueParentId: number | null;
    isActive: boolean;
    versionNumber: number;
    isRestricted: boolean;
    hasChildren: boolean;
    // Runtime-only fields (not from API)
    children?: CategoryNode[];
    isExpanded?: boolean;
    isLoadingChildren?: boolean;
}

export interface CategoryRestrictionSearchParams {
    CountryId: number;
    SearchText?: string;
    ZoneCategoryId?: number;
}
